import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useStoreAllNavs } from './allNavs';
import type { NavigationNode } from '../../types/link';

const storeId = 'store-navigation-social';

export type NavigationSocial = {
  items: NavigationNode[];
};

export const useStoreNavigationSocial = defineStore(storeId, () => {
  const storeAllNavs = useStoreAllNavs();
  const items = ref<NavigationSocial['items']>();

  async function fetchItems() {
    if (!storeAllNavs.allNavs?.socialNav) {
      console.error(`${storeId} >>> error`, 'allNavsStore is not available');
      return;
    }

    const navItems = new Array(storeAllNavs.allNavs.socialNav);

    if (navItems) {
      items.value = navItems;
    }
  }

  watch(storeAllNavs, () => {
    if (storeAllNavs.allNavs && !items.value) {
      fetchItems();
    }
  });

  return {
    items,
  };
});
